'use client';

import React from 'react';
import ProductCategorySlider from 'components/commercetools-ui/organisms/product-category-slider';
import { TasticProps } from '../types';

const ProductCategorySliderTastic = ({ data }: TasticProps<any>) => {
  return <ProductCategorySlider {...data} />;
};

export default ProductCategorySliderTastic;
